import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { goToCommunity } from '../utils/navigation';
import { Store, LogOut, Home } from 'lucide-react';

const VendorDashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // TODO: Replace with actual API calls
    const fetchVendorData = async () => {
      setLoading(true);
      try {
        // Mock API call - replace with actual implementation
        // const response = await apiService.getVendorDashboardData();
        // Process vendor data here
        
        // Simulate loading delay
        await new Promise(resolve => setTimeout(resolve, 1000));
      } catch (error) {
        console.error('Error fetching vendor data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchVendorData();
  }, []);

  const handleLogout = () => {
    logout();
  };

  const handleNavigation = (path: string) => {
    if (path === '/community') {
      goToCommunity();
    }
  };

  if (!user || !['VENDOR'].includes(user.role)) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>
          <p className="text-gray-600">You don't have permission to access this dashboard.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-4">
              <Store className="h-8 w-8 text-dpn-pink" />
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Vendor Dashboard</h1>
                <p className="text-sm text-gray-600">Welcome to your vendor space, {user.role}</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={() => handleNavigation('/community')}
                className="flex items-center space-x-2 text-dpn-olive hover:text-dpn-pink transition-colors duration-200"
              >
                <Home className="h-5 w-5" />
                <span>Home</span>
              </button>
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 text-dpn-olive hover:text-dpn-pink transition-colors duration-200"
              >
                <LogOut className="h-5 w-5" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {loading ? (
          <div className="bg-white rounded-lg shadow p-8 text-center">
            <div className="animate-spin rounded-full h-24 w-24 border-b-2 border-dpn-pink mx-auto mb-6"></div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Loading...</h2>
            <p className="text-lg text-gray-600">Preparing your vendor dashboard</p>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow p-8 text-center">
            <Store className="h-24 w-24 text-gray-400 mx-auto mb-6" />
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Coming Soon</h2>
            <p className="text-lg text-gray-600 mb-6">
              The Vendor Dashboard is currently under development. 
              We're working hard to bring you a comprehensive vendor management experience.
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 max-w-md mx-auto">
              <h3 className="font-semibold text-blue-900 mb-2">What's Coming:</h3>
              <ul className="text-sm text-blue-800 text-left space-y-1">
                <li>• Product and service management</li>
                <li>• Order tracking and fulfillment</li>
                <li>• Customer relationship management</li>
                <li>• Analytics and reporting</li>
                <li>• Payment and billing integration</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorDashboard;
